module.exports = __webpack_public_path__ + "img/right.d79181a0.svg";